import axios from 'axios'

import utils from './index.js'

import $logger from './logger.js'

export const transformHost = /geekbang\.com$/.test(location.host)

// 当前访问地址的 host
export const currentHost = location.host.replace(/(.*?)\.(.+?\..+?$)/, '$2')

// 当前访问地址的 domain
export const currentDomain = `.${currentHost}`

export default axios

/**
 * ajax 公共 httpRequest 方法
 * @extend axios
 * @param  {Object}   option                  配置
 * @param  {String}   option.logID            请求的串行独立 ID
 * @param  {String}   option.logUID           登录用户的 ID
 * @param  {Object}   option.logParams        自定义的附加属性
 * @param  {Boolean}  option.withCredentials  http 请求是否携带 cookie
 * @param  {Boolean}  option.transformHost    是否需要变更 host (org 转为 com)
 * @param  {Object}   option.headers          http 请求的 Headers
 * @param  {String}   option.type             http 请求的方式, 默认为 post
 * @param  {Object}   option.data             http 请求的参数
 * @param  {String}   option.host             http 请求的域名
 * @param  {String}   option.url              http 请求的地址
 * @param  {Function} option.progress         处理上传进度
 * @param  {Object}   option.cancelToken      用于 取消 http 请求
 * @param  {Object}   option.responseType     设置响应体类型
 * @return {Promise}
 */
export function ajax (option = {}) {
  let host = (option.host || '').replace(/\/*$/, '')

  if (transformHost && option.transformHost) {
    host = host.replace(/\.org$/, '.com')
  }

  let opt = {
    withCredentials: false
  }

  if (option.headers) {
    opt.headers = option.headers
  }

  if (option.withCredentials) {
    opt.withCredentials = option.withCredentials
  }

  if (option.responseType) {
    opt.responseType = option.responseType
  }

  opt.method = option.type || 'post'
  opt.url = /^\bhttp(s)?\b|\/\//.test(option.url) ? option.url : `${host}/${option.url.replace(/^\/*/, '')}`

  if (opt.method.toLocaleLowerCase() === 'get') {
    opt.params = Object.assign({
      v_t: Date.now()
    }, option.data)
  } else {
    opt.data = option.data
  }

  if (option.cancelToken) {
    opt.cancelToken = option.cancelToken
  }

  if (typeof option.progress === 'function') {
    opt.onUploadProgress = (progressEvent) => {
      option.progress(progressEvent)
    }
  }

  const logData = {
    reqID: `${option.logID || utils.uuid()}@1@${$logger.platform}`,
    uid: option.logUID,
    url: opt.url,
    method: opt.method,
    http_code: 200,
    cost: Date.now(),
    param: opt.headers && opt.headers['Content-Type'] === 'multipart/form-data' ? {} : option.data,
    extra: option.logParams
  }

  opt.headers = Object.assign({}, opt.headers, {
    'X-GEEK-REQ-ID': logData.reqID
  })

  return axios(opt).then(res => {
    let result
    let {code, error = {}, message: msg, status_code: statusCode = res.status} = res.data
    let message = ''

    // 公共请求日志上报
    $logger.request(Object.assign({}, logData, {
      http_code: +statusCode || res.status,
      cost: Date.now() - logData.cost
    }))

    code = error.code || code
    message = message = msg || error.msg || ''

    if (res.status === 200) {
      // 无 code 多用于获取 json 文件等
      if (code === undefined) {
        result = res.data
      }

      // 公共处理接口的方式
      if (code === 0) {
        result = res.data.data || {}
      }
    }

    if (result) {
      return result
    }

    // 添加错误类型, api 为 1 时为可捕获的异常
    error.response = res
    error.api = 1
    error.code = code | 0
    error.message = message
    error.statusCode = +statusCode

    return Promise.reject(error)
  }).catch(err => {
    // 非捕获性异常，需要上报
    if (!err.api) {
      let statusCode = 0

      // 请求成功发出且服务器也响应了状态码
      if (err.response) {
        statusCode = (err.response.data && err.response.data.status_code) || err.response.status
      }

      // 公共请求日志上报
      $logger.request(Object.assign({}, logData, {
        http_code: statusCode,
        cost: Date.now() - logData.cost,
        msg: typeof err === 'object' && err.api ? {code: err.code, message: err.message} : err
      }))
    }

    return Promise.reject(typeof err === 'object' && err.api ? err : {
      api: 0,
      error: err
    })
  })
}
